import ApiService from './ApiService';

export interface PersonalInfo {
  location: string;
  title: string;
  birthday: string;
  phoneNumber: string;
  facebook: string;
  twitter: string;
  pinterest: string;
  linkedIn: string;
}

export interface OrderHistory {
  id: string;
  item: string;
  status: string;
  amount: number;
  date: number;
}

export interface PaymentMethod {
  cardHoldername: string;
  cardType: string;
  expMonth: string;
  expYear: string;
  last4Number: string;
  primary: boolean;
}

export interface Subscription {
  plan: string;
  status: string;
  billing: string;
  nextPaymentDate: number;
  amount: number;
}

export interface ICustomer {
  id: string;
  name: string;
  email: string;
  img: string;
  role: string;
  lastOnline: number;
  status: string;
  personalInfo: PersonalInfo;
  orderHistory: OrderHistory[];
  paymentMethod: PaymentMethod[];
  subscription: Subscription[];
}

export interface TotalCustomers {
  value: number;
  growShrink: number;
}

export interface ActiveCustomers {
  value: number;
  growShrink: number;
}

export interface NewCustomers {
  value: number;
  growShrink: number;
}

export interface ICustomersStatistic {
  totalCustomers: TotalCustomers;
  activeCustomers: ActiveCustomers;
  newCustomers: NewCustomers;
}

export type GetCustomerById_Params = { id: string };
export type GetCustomerById_Response = IResponse<ICustomer | null>;
export const getCustomerById = async (params: GetCustomerById_Params) => ApiService.fetchData<GetCustomerById_Response>({ url: `http://localhost:5000/userData/${params.id}`, method: 'get' });

export type GetCustomers_Response = IResponse<Array<ICustomer> | null>;
export const getCustomersList = async () => ApiService.fetchData<GetCustomers_Response, undefined>({ url: 'http://localhost:5000/userData', method: 'get' });

export type GetCrmCustomersStatistic_Response = IResponse<Array<ICustomersStatistic> | null>;
export const getCrmCustomersStatistic = async () => ApiService.fetchData<GetCrmCustomersStatistic_Response, undefined>({ url: 'http://localhost:5000/customerStatistic', method: 'get' });
